import { Box, Button } from "@mui/material";
import PagesContainer from "../../../components/UI/PagesContainer";
import Triages from "./Triages";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { defaultScrollTheme } from "../../../utils/utils";

const MyTriages = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const onClickHandler = () => {
    navigate("/triage/newTriage");
  };

  return (
    <PagesContainer
      title={t("page.triageEmergencyDepartment.my_triages")}
      subtitle={t("page.triageEmergencyDepartment.subtitle")!}
      rowActions={
        <Button variant="contained" onClick={onClickHandler}>
          {t("page.triageEmergencyDepartment.add")}
        </Button>
      }
    >
      <Box
        height={"calc(100% - 48px)"}
        overflow={"auto"}
        sx={defaultScrollTheme}
      >
        <Triages />
      </Box>
    </PagesContainer>
  );
};

export default MyTriages;
